module.exports = __webpack_public_path__ + "videos/whatsnew-gradientmap_cn.a05e931.mp4";